"use strict";
exports.__esModule = true;
exports.setupDeveloperEndpoints = void 0;
var utils_1 = require("../utils");
var getBasePath = (0, utils_1.getBasePathFactory)('/developer');
function setupDeveloperEndpoints(api) {
    return api.injectEndpoints({
        endpoints: function (build) { return ({
            generateDevLogin: build.mutation({
                query: function (_a) {
                    var phone_number = _a.phone_number, reset_account = _a.reset_account;
                    return ({
                        url: "".concat(getBasePath(), "/login"),
                        method: 'POST',
                        body: { phone_number: phone_number, reset_account: reset_account }
                    });
                }
            })
        }); }
    });
}
exports.setupDeveloperEndpoints = setupDeveloperEndpoints;
